<template>
  <tr>
    <template v-for="(value, index) in arrWeek">
      <template v-if="value != ''">
        <td :class="'typwork-' + callTypwork(selectedMonth, value)" v-on:click="setSelectDate({ date: value, day: index })">
          <div class="clearfix">
            <div class="set-number-date">{{ value }}</div>
          </div>
        </td>
      </template>
      <template v-else>
        <td><div></div></td>
      </template>
    </template>
  </tr>
</template>

<script>
export default {
  name: 'hrms-week-row',
  props: [ 'arrWeek', 'setSelectDate', 'checkCurrentDay', 'checkSelectedDay', 'selectedMonth', 'typwork' ],
  methods: {
    callTypwork (month, day) {
      if (this.typwork[month - 1]) {
        if (this.typwork[month - 1][day - 1]) {
          return this.typwork[month - 1][day - 1]
        } else {
          return 'w'
        }
      } else {
        return 'w'
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// hrmsWeekRow.vue?172c8304